import { React } from '_core';

const MetricBasketReturnsBySector = () => <></>;
export default MetricBasketReturnsBySector;
